<template>
  <div class="page">
    <div class="content">
      <div class="w-jf">
        <img src="@images/gzfw/icon-jf.png" class="icon-jf" />
        <span class="jf">{{ jf }}</span>
        <span class="plus" :class="{ pluss: pluss }">+{{ plussNum }}</span>
      </div>
      <div class="jfsc" @click="clickJfsc">积分商城</div>
      <div class="jfgz" @click="show = true">积分规则</div>

      <div class="cloud">
        <div class="fly-1"></div>
        <div class="fly-2"></div>
      </div>
      <div class="bottom">
        <img
          src="@images/gzfw/tree.png"
          class="tree"
          mode="widthFix"
          :class="[treemove ? 'move' : '']"
          hover-class="none"
          @click="tree"
        />
        <div class="waters" v-show="waterdom"></div>
      </div>
    </div>
    <div class="p-js">
      <img src="@images/gzfw/bg-sh.png" class="sh-bg" />
      <img src="@images/gzfw/icon-sh.png" class="sh" :class="{ water: watercss }" @click="water" />
    </div>
    <jfgz-pop v-model="show"></jfgz-pop>
  </div>
</template>

<script>
import { getAction, postAction, postParam } from '@/api/manage'
import JfgzPop from '@/views/common/jfgz-pop.vue'
export default {
  components: {
    JfgzPop,
  },
  data() {
    return {
      plussNum: +1, // 加值数量（默认1）
      pluss: false, // 水滴值+1动画开关
      movetree: true, // 树动画开关
      treemove: false, // 树大小动画类型开关
      wateroff: true, // 浇水动画开关
      watercss: false, // 水壶动画开关
      waterdom: false, // 水滴动画开关
      jf: 0,
      jd: '',
      wd: '',
      address: '',
      show: false,
    }
  },
  created() {
    this.initData()
  },
  mounted() {},
  computed: {},
  methods: {
    initData() {
      getAction('/zhshj/xtjfgl/getjf').then((res) => {
        if (res.code == 200) {
          this.jf = res.result
        }
      })
    },
    water() {
      if (this.wateroff) {
        this.watercss = true
        this.wateroff = false

        setTimeout(() => {
          this.waterdom = true
        }, 1500)

        setTimeout(() => {
          this.treemove = true
          this.movetree = false
          this.addJf()
        }, 2000)

        setTimeout(() => {
          this.waterdom = false
          this.movetree = true
        }, 3500)

        this.setTree()
      }
    },
    setTree(time = 4000) {
      setTimeout(() => {
        this.plussNum = 1
        this.pluss = false
        this.wateroff = true
        this.watercss = false
        this.treemove = false
      }, time)
    },
    tree() {
      if (this.movetree) {
        this.treemove = true
        this.movetree = false
        setTimeout(() => {
          this.movetree = true
          this.treemove = false
        }, 1000)
      }
    },
    addJf() {
      let params = { jd: this.jd, wd: this.wd, czpt: '3', address: this.address }
      postAction('/zhshj/qdjl/add-app', params).then((res) => {
        if (res.success) {
          this.jf++
          this.pluss = true
        } else {
          this.$toast(res.message)
        }
      })
    },
    clickJfsc() {
      this.YzJfsc().then(() => {
        this.$router.push({
          path: '/gzfw/jfsc',
        })
      })
    },
    YzJfsc() {
      return new Promise((resolve, reject) => {
        getAction('/zhshj/jfschdgl/hdxx').then((res) => {
          if (res.success) {
            let obj = res.result[0]
            if (obj.zt == '01') {
              resolve()
            } else {
              let message = `积分商城已在${obj.gbsj}关闭，开放时间：${obj.kfsj}`
              this.$toast(message)
              reject()
            }
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: 100vh;
  margin: 0px;
  background: url('~@images/gzfw/bg.png') no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;
  overflow: hidden;
}

.w-jf {
  min-width: 98px;
  height: 35px;
  background: #56c8ff33;
  box-shadow: inset 0 0 10px 5px #99d3ffc9;
  border-radius: 16px;
  display: inline-flex;
  align-items: center;
  margin-top: 10px;
  margin-left: 14px;
  padding: 0 9px;
  position: relative;

  .icon-jf {
    width: 25px;
    height: 25px;
    margin-right: 9px;
  }
  .jf {
    font-weight: 600;
    font-size: 18px;
    color: #fbe945;
  }
}

.bottom {
  position: absolute;
  bottom: 40px;
  display: flex;
  width: 100%;
  .tree {
    width: 273px;
    height: 285px;
    margin-bottom: 84px;
    margin-left: 35px;
  }
}

.p-js {
  width: 99px;
  height: 99px;
  position: absolute;
  bottom: 40px;
  right: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  .sh {
    width: 89px;
    height: 80px;
    position: absolute;
    z-index: 97;
    right: 10px;
    bottom: 15px;
  }
  .sh-bg {
    width: 81px;
    height: 81px;
    position: absolute;
    z-index: 96;
    bottom: 0;
  }
}
@keyframes water {
  0% {
    opacity: 0.5;
    transform: translate3d(0, 0, 0);
  }

  20% {
    opacity: 1;
    transform: translate3d(-60px, -80px, 0) scale(1.2);
  }

  30% {
    opacity: 1;
    transform: translate3d(-60px, -80px, 0) scale(1.2) rotate(-35deg);
  }

  80% {
    opacity: 1;
    transform: translate3d(-60px, -80px, 0) scale(1.2) rotate(-35deg);
  }

  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.water {
  animation: water 4s ease-in-out forwards;
}
@keyframes move {
  0% {
    height: 290px;
  }

  10% {
    height: 292px;
  }

  20% {
    height: 295px;
  }

  40% {
    height: 280px;
  }

  70% {
    height: 300px;
  }

  100% {
    height: 285px;
  }
}

.move {
  animation: move 1s;
}

.plus {
  position: absolute;
  top: 20px;
  right: -20px;
  font-size: 16px;
  opacity: 0;
  color: #ffbe2d;
}

@keyframes pluss {
  0% {
    opacity: 0.8;
    top: 5px;
  }
  50% {
    opacity: 1;
    top: -30px;
  }

  80% {
    opacity: 1;
    top: -40px;
  }

  100% {
    opacity: 0;
    top: -60px;
  }
}

.pluss {
  animation: pluss 2s;
}

.waters {
  position: absolute;
  bottom: 60px;
  right: 200px;
  width: 42px;
  height: 75px;
  background: url('~@images/gzfw/waters.gif') no-repeat;
  background-size: contain;
  transition: all 1.8s;
  z-index: 9;
}

.cloud .fly-1 {
  width: 135px;
  height: 44px;
  animation: cloud-1 80s ease-in-out 0s infinite alternate;
  background: url('~@images/gzfw/fly-1.png') no-repeat;
  background-size: contain;
}

.cloud .fly-2 {
  width: 95px;
  height: 30px;
  margin-top: 60px;
  animation: cloud-2 60s linear 0s infinite alternate;
  background: url('~@images/gzfw/fly-2.png') no-repeat;
  background-size: contain;
}
@keyframes cloud-1 {
  0% {
    opacity: 0.8;
    transform: translate3d(200%, 0, 0);
  }

  50% {
    opacity: 0.6;
    transform: translate3d(800%, 0, 0) scale(1.3);
  }

  100% {
    opacity: 0.8;
    transform: translate3d(-120%, 0, 0);
  }
}

@keyframes cloud-2 {
  0% {
    opacity: 0.8;
    transform: translate3d(820%, 0, 0);
  }

  50% {
    opacity: 0.6;
    transform: translate3d(-120%, 0, 0);
  }

  100% {
    opacity: 0.8;
    transform: translate3d(1080%, 0, 0) scale(1.3);
  }
}

.jfgz {
  position: absolute;
  width: 85px;
  height: 35px;
  background-image: linear-gradient(180deg, #7fb4ff 0%, #7a9fff 100%);
  border-radius: 18px;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 35px;
  right: 15px;
  top: 55px;
  z-index: 1;
}

.jfsc {
  position: absolute;
  width: 85px;
  height: 35px;
  background: #f9edd2;
  box-shadow: inset 0 0 8px 0 #ffffff80;
  border-radius: 18px;
  font-weight: 500;
  font-size: 14px;
  color: #ff7e3b;
  text-align: center;
  line-height: 35px;
  right: 15px;
  top: 10px;
}

/deep/ .van-popup--center {
  top: 45%;
}
</style>
